import { message, PageHeader, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { cuentaMask, TableItem, ButtonItem } from "../../../Components/Items";
import { EditOutlined, ImportOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "./AgregarCuentaContable/AgregarCuentaContable";
import EditarCuentaContable from "./EditarCuentaContable/EditarCuentaContable";

class CuentasContables extends Component {
  state = {
    todasCuentasContables: [],
    modalAgregarCuentaContable: false,
    modalEditarCuentaContable: false,
    modalEditarCuentaContableId: null,
    loading: false
  };
  componentDidMount() {
    this.consultarCuentasContables();
  }
  consultarCuentasContables() {
    this.setState({ loading: true })
    axios
      .post(
        "cuentascontables/selectTodasCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasCuentasContables: res.data.map((value) => {
              return {
                ...value,
                codigo: cuentaMask(
                  value.nivel1 +
                  value.nivel2 +
                  value.nivel3 +
                  value.nivel4 +
                  value.nivel5
                ),
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
        }
      });
  }
  importarCuentasContables() {
    this.props.history.push("/panel/importarCuentasContables");
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarCuentasContables();
  }
  abrirEditarCuentaContable(id) {
    this.setState({ modalEditarCuentaContable: true, modalEditarCuentaContableId: id });
  }
  cerrarEditarCuentaContable() {
    this.setState({ modalEditarCuentaContable: false, modalEditarCuentaContableId: null });
    this.consultarCuentasContables();
  }
  deshabilitarCuentaContable(value) {
    axios
      .post(
        "cuentascontables/deshabiltarCuentaContable",
        { cuentaContableId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Cuenta contable deshabilitada correctamente");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.consultarCuentasContables();
      });
  }
  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value) => {
          let buttons = [];

          const puedeEditar = this.props.permisoEditarCuentaContable;
          buttons.push(
            <Tooltip key="editar" title={puedeEditar ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => puedeEditar && this.abrirEditarCuentaContable(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // buttons.push(
          //   <Tooltip key="deshabiltar" title={puedeEditar ? "Deshabilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
          //     <ButtonItem
          //       type="default"
          //       size="small"
          //       cyan
          //       icon={<DeleteOutlined />}
          //       onClick={() => puedeEditar && this.deshabilitarCuentaContable(value._id)}
          //     >
          //     </ButtonItem>
          //   </Tooltip>
          // );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Cuentas Contables"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            this.props.permisoAgregarCuentaContable && (
              <ButtonItem
                key="importarCuentasContables"
                type="default"
                icon={<ImportOutlined />}
                onClick={this.importarCuentasContables.bind(this)}
              >
                Importar Cuentas Contables
              </ButtonItem>
            ),
            this.props.permisoAgregarCuentaContable && (
              <ButtonItem
                type="primary"
                key="agregarCuentaContable"
                olivo
                onClick={this.abrirAgregarCuentaContable.bind(this)}
                className="botonAgregar"
              >
                Agregar Cuenta Contable
              </ButtonItem>
            ),
          ]}
        />
        <TableItem
          loading={this.state.loading}
          size='small'
          dataSource={this.state.todasCuentasContables}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => this.abrirEditarCuentaContable(record._id),
          })}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
        <EditarCuentaContable
          visible={this.state.modalEditarCuentaContable}
          id={this.state.modalEditarCuentaContableId}
          cerrarEditarCuentaContable={this.cerrarEditarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarCuentaContable: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cda85f30e81b54183cf9d")?.activado,
    permisoEditarCuentaContable: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce731f30e81b54183cfb5")?.activado,
  };
};

export default connect(mapStateToProps)(CuentasContables);
